import { ACTIVITY_FIELD_TYPE } from 'utils/activityTracking/constants';

/**
 * Resolves the `field_type` attribute from the server-driven form config (BEAST-13036).
 *
 * NEVER from the DOM `type` attribute, which MUI rewrites, and never from anything derived from
 * what the agent typed. The inputs here are exactly the two the switch in `TransactionForm` uses to
 * decide which input component to render, so this mapping tracks that decision rather than
 * guessing at the rendered markup.
 *
 * `checkbox` and `input_select` are in the frozen map because `Checkbox` / `FormCheckBox` and
 * `inputSelect` are two of the six input components, but the transaction form does not currently
 * route any field to them - a boolean field arrives with a Yes/No `dataSource` and renders as a
 * select. They stay in the vocabulary so a form config that does reach them has a token waiting.
 */
export function resolveActivityFieldType({ dataType, lookup } = {}) {
    if (typeof dataType === 'string' && dataType.includes('date')) return ACTIVITY_FIELD_TYPE.DATE;

    if (lookup?.dataSource) {
        // A strict option list has a `displayExpr`; without one the input is a free-solo
        // autocomplete, which is a materially different interaction to record.
        return lookup.displayExpr ? ACTIVITY_FIELD_TYPE.SELECT : ACTIVITY_FIELD_TYPE.AUTOCOMPLETE;
    }

    return ACTIVITY_FIELD_TYPE.TEXT;
}

/** Builds a `dataField -> field_type` lookup once per form config, so focus handling is O(1). */
export function buildFieldTypeMap(formConfigFields) {
    const map = {};
    (formConfigFields ?? []).forEach((field) => {
        if (!field?.dataField) return;
        map[field.dataField] = resolveActivityFieldType(field);
    });
    return map;
}
